import { render } from "./KoreanNumbers.vue?vue&type=template&id=94ef1ba4&scoped=true"
import script from "./KoreanNumbers.vue?vue&type=script&lang=ts"
export * from "./KoreanNumbers.vue?vue&type=script&lang=ts"

import "./KoreanNumbers.vue?vue&type=style&index=0&id=94ef1ba4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-94ef1ba4"

export default script